import { render, staticRenderFns } from "./UmIndustry.vue?vue&type=template&id=c984e11c&scoped=true&"
import script from "./UmIndustry.vue?vue&type=script&lang=js&"
export * from "./UmIndustry.vue?vue&type=script&lang=js&"
import style0 from "./UmIndustry.vue?vue&type=style&index=0&id=c984e11c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c984e11c",
  null
  
)

export default component.exports